// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class SearchRequest extends TrackingModel {
	public SearchRequestId: number = 0;
	public SearchRequestTypeId: number = 0;
	public PersonId?: number;
	public Name: string = "";
	public Description?: string;
	public SearchRequestJson: string = "";
}